import React from "react";
import _ from "lodash";
import T from "prop-types";
import { Link } from "react-router-dom";
import { truncate } from "LIB/formatters/text";
import { CompanyStatsTooltip } from "MODULES/shared/components";

// Converts flattened company data into a company object.
//
// Example
// Original data: { id: 1, company_id: 99, company_name: 'Foo Bar', company_company_type: 'repair_station' }
// Returned data: { id: 99, name: 'Foo Bar', company_type: 'repair_station' }
function enhanceCompany(flattenedCompany) {
  return Object.keys(flattenedCompany || {})
    .filter(key => key.startsWith("company_"))
    .reduce((result, key) => {
      result[_.replace(key, /^company_/, "")] = flattenedCompany[key];
      return result;
    }, {});
}

export default function CompanyName({
  company,
  flattenedCompany,
  statsTooltip,
  context,
  truncateAt
}) {
  const enhancedCompany = company || enhanceCompany(flattenedCompany);

  if (_.isEmpty(enhancedCompany)) {
    return false;
  }

  const companyName = truncateAt
    ? truncate(enhancedCompany.name, truncateAt)
    : enhancedCompany.name;

  return (
    <div>
      {enhancedCompany.id || enhancedCompany.uuid ? (
        <Link
          onClick={e => e.stopPropagation()}
          to={`/companies/${enhancedCompany.uuid || enhancedCompany.id}`}
        >
          {companyName}
        </Link>
      ) : (
        companyName
      )}
      {enhancedCompany.id &&
        statsTooltip && (
          <React.Fragment>
            &nbsp;
            <CompanyStatsTooltip company={enhancedCompany} context={context} />
          </React.Fragment>
        )}
    </div>
  );
}

CompanyName.propTypes = {
  company: T.shape({
    id: T.number.isRequired,
    name: T.string.isRequired,
    company_type: T.string.isRequired
  }).isRequired,
  flattenedCompany: T.shape({}),
  statsTooltip: T.bool,
  context: T.oneOf(["standard", "repair"]),
  truncateAt: T.number
};

CompanyName.defaultProps = {
  statsTooltip: true,
  context: "standard"
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CompanyName/CompanyName.jsx